<div class="modal-container">
  <div
    class="modal-header"
    [ngClass]="{ warning: confirmationType() === 'warning' }"
  >
    <h3>{{ headerText() }}</h3>
    <button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <div>{{ bodyText() }}</div>
    @if(confirmButtonWarningMessage()){
      <div>{{ confirmButtonWarningMessage() }}</div>
    }
  </div>
  <div class="modal-footer">
    <button
      class="cancel-button"
      [class.primary-button]="primaryAction() === 'cancel'"
      [class.secondary-button]="primaryAction() === 'confirm'"
      [class.warning-button]="
        confirmationType() === 'warning' && primaryAction() === 'confirm'
      "
      (click)="onCancel()"
    >
      {{ cancelButtonText() }}
    </button>

    <button
      class="confirm-button"
      [class.warning-button]="confirmationType() === 'warning'"
      [class.secondary-button]="primaryAction() === 'cancel'"
      (click)="onConfirm()"
    >
      {{ confirmButtonText() }}
    </button>
  </div>
</div>
